import RouteWrapper, { RouteProps } from 'src/routes/RouteWrapper'

const PrivateRoute: React.FC<RouteProps> = ({ ...rest }) => {
  return <RouteWrapper {...rest} isPrivate />
}

export default PrivateRoute
